import React, { useState } from 'react';
import api from '../api';

export default function Auth({ onLogin }) {
  const [mode, setMode] = useState('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const expired = new URLSearchParams(window.location.search).get('expired') === '1';

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post(`/auth/${mode}`, { username, password });
      onLogin(res.data.user, res.data.token);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '60px auto', padding: '0 16px' }}>
      <div style={{
        background: 'var(--color-surface)',
        borderRadius: 'var(--radius-card)',
        padding: 32,
        border: '1px solid var(--color-border)',
        boxShadow: 'var(--shadow-card)',
      }}>
        <h2 style={{
          marginBottom: 8,
          fontSize: 28,
          fontWeight: 700,
          fontFamily: 'var(--font-display)',
          color: 'var(--color-text-primary)',
        }}>
          {mode === 'login' ? 'Sign In' : 'Create Account'}
        </h2>
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: 14,
          color: 'var(--color-text-muted)',
          marginBottom: 24,
        }}>
          {mode === 'login' ? 'Welcome back to IsItTrueNow.' : 'Join the debate.'}
        </p>
        {expired && mode === 'login' && (
          <p style={{ fontFamily: 'var(--font-body)', fontSize: 13, color: 'var(--color-text-secondary)', marginTop: -12, marginBottom: 20 }}>
            Your login expired. Sign in again to pick up where you left off.
          </p>
        )}
        <form onSubmit={submit}>
          <label style={labelStyle}>Username</label>
          <input
            style={inputStyle}
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            autoFocus
          />
          <label style={labelStyle}>Password</label>
          <input
            type="password"
            style={inputStyle}
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          {error && (
            <p style={{
              color: 'var(--color-invalidated)',
              fontSize: 13,
              marginBottom: 12,
              fontFamily: 'var(--font-body)',
            }}>
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            style={submitBtn}
            onMouseEnter={e => (e.currentTarget.style.background = 'var(--color-brand-hover)')}
            onMouseLeave={e => (e.currentTarget.style.background = 'var(--color-brand)')}
          >
            {loading ? 'Loading...' : mode === 'login' ? 'Sign In' : 'Register'}
          </button>
        </form>
        <p style={{
          marginTop: 20,
          fontSize: 13,
          color: 'var(--color-text-muted)',
          textAlign: 'center',
          fontFamily: 'var(--font-body)',
        }}>
          {mode === 'login' ? "Don't have an account? " : 'Already have an account? '}
          <button
            onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setError(''); }}
            style={{
              background: 'none', border: 'none',
              color: 'var(--color-brand)', cursor: 'pointer',
              fontSize: 13, fontFamily: 'var(--font-body)',
              fontWeight: 600, padding: 0,
            }}
          >
            {mode === 'login' ? 'Register' : 'Sign In'}
          </button>
        </p>
      </div>
    </div>
  );
}

const labelStyle = {
  display: 'block',
  fontSize: 12,
  fontWeight: 600,
  color: 'var(--color-text-secondary)',
  marginBottom: 6,
  fontFamily: 'var(--font-body)',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
};

const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  marginBottom: 16,
  background: 'var(--color-bg)',
  border: '1px solid var(--color-border)',
  borderRadius: 8,
  color: 'var(--color-text-primary)',
  fontSize: 14,
  outline: 'none',
  fontFamily: 'var(--font-body)',
  boxSizing: 'border-box',
  transition: 'border-color 0.15s ease',
};

const submitBtn = {
  width: '100%',
  padding: '11px',
  background: 'var(--color-brand)',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  cursor: 'pointer',
  fontSize: 15,
  fontWeight: 600,
  fontFamily: 'var(--font-body)',
  transition: 'background 0.15s ease',
};
